const FilterIcon = ({ active }: { active: boolean }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill={active ? "#0466B4" : "none"}
    data-testid="filter-icon"
  >
    <path
      d="M15 1H1L6.25 6.25V15L9.75 12.98V6.25L15 1Z"
      stroke={active ? "#0466B4" : "#7C7D7D"}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default FilterIcon;
